import FeedbackTriage from '../components/FeedbackTriage';

export default function FeedbackAdminPage() {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Feedback Inbox</h1>
        <p className="text-sm text-gray-500 mt-1">
          Review and triage submitted feedback. AI analysis is shown for finalized items.
        </p>
      </div>
      <FeedbackTriage />
    </div>
  );
}
